// ============================================================
// Taksitlendirme planı formu (§5)
//
// Ödeme güçlüğü çeken veliyle anlaşma yapmak, hatırlatma göndermeye
// devam etmekten iyidir: çocuk her gün o kurumda ve ilişki sürüyor.
// Plan açılınca hatırlatmalar askıya alınır.
// ============================================================

import { closeModal } from "./studentModal.js";
import { avatar } from "../lib/avatar.js";
import { esc, fmtDate, money } from "../lib/fmt.js";
import { B, stu } from "../domain/context.js";
import { BUGUN } from "../config.js";
import { faturaTutari, tahsilEdilen } from "../domain/invoices.js";
import { ogrencininTaksitPlani } from "../domain/reminders.js";
import { Hatirlatma } from "../repo/entities.js";
import { oturum } from "../domain/auth.js";
import { rerender } from "../lib/rerender.js";
import { state } from "../state.js";

export function openTaksitFormu(studentId) {
  const s = stu(studentId);
  if (!s) return;
  if (ogrencininTaksitPlani(s.id, state.branchId)) return;

  const t = B();
  const acikFaturalar = t.payments
    .filter(p => p.studentId === s.id)
    .map(p => ({ p, kalan: faturaTutari(s, p) - tahsilEdilen(p) }))
    .filter(x => x.kalan > 0);

  const toplam = acikFaturalar.reduce((a, x) => a + x.kalan, 0);

  document.getElementById("modalBox").innerHTML = `
    <div class="p-6">
      <div class="flex items-start gap-4">
        ${avatar(s, "w-12 h-12")}
        <div class="flex-1 min-w-0">
          <h2 class="font-display font-bold text-lg">${esc(s.name)} — Taksitlendirme</h2>
          <p class="text-xs text-inksoft mt-0.5">
            ${acikFaturalar.length} açık dönem · toplam ${money(toplam)}
          </p>
        </div>
        <button id="modalClose" class="p-1.5 rounded-lg hover:bg-paper" aria-label="Kapat">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      ${toplam ? `
        <div class="rounded-xl bg-paper p-3 mt-4">
          <div class="text-[11px] font-bold text-inksoft uppercase mb-1.5">Açık dönemler</div>
          ${acikFaturalar.map(x => `
            <div class="flex items-center justify-between gap-2 text-xs py-0.5">
              <span class="text-inksoft">${x.p.period} · vade ${fmtDate(x.p.due)}</span>
              <span class="font-semibold">${money(x.kalan)}</span>
            </div>`).join("")}
          <div class="flex items-center justify-between gap-2 text-sm font-display font-bold mt-2 pt-2 border-t border-line">
            <span>Toplam</span><span>${money(toplam)}</span>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-3 mt-4">
          <label class="block">
            <span class="text-[11px] font-bold text-inksoft uppercase">Taksit sayısı</span>
            <select id="tksAdet" class="w-full mt-1 rounded-xl border border-line px-3 py-2 text-sm bg-white">
              ${[2, 3, 4, 6].map(n => `<option value="${n}" ${n === 4 ? "selected" : ""}>${n} taksit</option>`).join("")}
            </select>
          </label>
          <label class="block">
            <span class="text-[11px] font-bold text-inksoft uppercase">İlk taksit tarihi</span>
            <input id="tksIlk" type="date" value="${ilkTarih()}"
              class="w-full mt-1 rounded-xl border border-line px-3 py-2 text-sm bg-white">
          </label>
        </div>

        <label class="block mt-3">
          <span class="text-[11px] font-bold text-inksoft uppercase">Görüşme notu</span>
          <textarea id="tksNot" rows="2" placeholder="Veli ile ne konuşuldu?"
            class="w-full mt-1 rounded-xl border border-line px-3 py-2 text-sm bg-white"></textarea>
        </label>

        <div id="tksOnizleme" class="rounded-xl border border-teal/40 bg-teal-soft/30 p-3 mt-3"></div>

        <p class="text-[11px] text-inksoft mt-3">
          Plan açılınca bu öğrenci için otomatik hatırlatmalar askıya alınır.
          Taksitler geciktiğinde plan yeniden değerlendirilmeli.
        </p>

        <div class="flex items-center gap-2 mt-4">
          <button id="tksKaydet" class="rounded-xl bg-teal text-white text-sm font-semibold px-4 py-2">Planı oluştur</button>
          <button id="tksVazgec" class="rounded-xl border border-line bg-white text-sm font-semibold px-4 py-2">Vazgeç</button>
        </div>`
      : `<p class="text-sm text-inksoft mt-4">Bu öğrencinin açık bakiyesi yok.</p>`}
    </div>`;

  const modal = document.getElementById("modal");
  modal.classList.remove("hidden");
  modal.classList.add("flex");
  document.getElementById("modalClose").onclick = closeModal;

  if (!toplam) return;

  document.getElementById("tksVazgec").onclick = closeModal;

  const onizle = () => {
    const adet = Number(document.getElementById("tksAdet").value);
    const ilk = document.getElementById("tksIlk").value || ilkTarih();
    const taksitler = taksitleriUret(toplam, adet, ilk);
    document.getElementById("tksOnizleme").innerHTML = `
      <div class="text-[11px] font-bold text-teal uppercase mb-1.5">Plan önizlemesi</div>
      ${taksitler.map(t => `
        <div class="flex items-center justify-between gap-2 text-xs py-0.5">
          <span class="text-inksoft">${t.no}. taksit · ${fmtDate(t.dueAt)}</span>
          <span class="font-semibold">${money(t.amount)}</span>
        </div>`).join("")}`;
  };

  document.getElementById("tksAdet").onchange = onizle;
  document.getElementById("tksIlk").onchange = onizle;
  onizle();

  document.getElementById("tksKaydet").onclick = () => {
    const adet = Number(document.getElementById("tksAdet").value);
    const ilk = document.getElementById("tksIlk").value || ilkTarih();

    Hatirlatma.taksitPlaniAc(state.branchId, {
      id: `tks-${Date.now().toString(36)}`,
      studentId: s.id,
      olusturmaAt: BUGUN,
      olusturan: oturum()?.name ?? "—",
      not: document.getElementById("tksNot").value.trim(),
      closedAt: null,
      installments: taksitleriUret(toplam, adet, ilk),
    }, s);

    closeModal();
    rerender();
  };
}

/** Taksitleri eşit böler; yuvarlama farkı ilk taksite eklenir. */
export function taksitleriUret(toplam, adet, ilkTarih) {
  const taban = Math.floor(toplam / adet / 50) * 50;
  const list = [];

  for (let i = 0; i < adet; i++) {
    list.push({
      no: i + 1,
      dueAt: ayEkle(ilkTarih, i),
      amount: i === 0 ? toplam - taban * (adet - 1) : taban,
      paidAt: null,
    });
  }
  return list;
}

function ayEkle(iso, ay) {
  const d = new Date(iso + "T00:00:00Z");
  d.setUTCMonth(d.getUTCMonth() + ay);
  return d.toISOString().slice(0, 10);
}

function ilkTarih() {
  const d = new Date(BUGUN + "T00:00:00Z");
  d.setUTCDate(d.getUTCDate() + 15);
  return d.toISOString().slice(0, 10);
}
